module.exports = __webpack_public_path__ + "media/customize/banner-modern-bottom-24ebcf1d.svg";